<template>
  <div class="message">
    <el-button type="primary" @click="readAll" size="mini" style="float: right;">全部已读</el-button>
    <commonHeader :title="'消息通知'"></commonHeader>
    <userCenterTable
      :isShowLoading="isShowLoading"
      :tableData="tableData"
      :totalCount="totalCount"
      :pageSize="params.pageSize"
      :pageNumber="params.pageNumber"
      :field-data="fieldData"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
      <template v-slot:messageTitle="scope">
        <span style="cursor: pointer;" @click="goDetail(scope.data)">{{ scope.data.messageTitle }}</span>
      </template>
    </userCenterTable>

    <el-dialog
        class="messageDetail"
        title="通知详情"
        width="900px"
        :visible.sync="messageDetailDialog"
        @close="refresh"
    >
      <div class="message-area">
        <div class="message-row">
          <div class="message-title">通知标题</div>
          <div class="message-content nowrap">{{ messageDetail.messageTitle }}</div>
        </div>
        <div class="message-row">
          <div class="message-title">通知时间</div>
          <div class="message-content">{{ messageDetail.inputTime }}</div>
        </div>
        <div class="message-row">
          <div class="message-title">通知内容</div>
          <div class="message-content" style="min-height: 200px">
            <p style="">{{ messageDetail.messageContent }}</p>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { baseContent } from '../mixin/baseContent'
export default {
  name: 'Message',
  mixins: [baseContent],
  data() {
    return {
      messageDetail: '',
      messageDetailDialog: false,
      dataUrl: '/front/userCenter/messagePage',
      fieldData: [
        {
          field: 'messageTitle',
          label: '通知标题',
          width: '500',
          type: 'customize'
        },
        {
          field: 'readStatus',
          label: '状态',
          width: '100',
          type: 'status',
          statusOption: {
            'read': {
              className: 'greenTag',
              label: '已读'
            },
            'unread': {
              className: 'grayTag',
              label: '未读'
            }
          }
        },
        {
          field: 'inputTime',
          label: '通知时间',
          width: '170',
          type: 'text'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    readAll() {
      this.$get('/front/userCenter/readAll').then(() => {
        this.refresh()
      })
    },
    refresh() {
      this.fetchData()
      this.$emit('getNoRead')
    },
    goDetail(data) {
      this.$get('/front/userCenter/messageInfo', data.pkid).then(() => {
      })
      this.messageDetail = data
      this.messageDetailDialog = true
    }
  }
}
</script>

<style lang="scss" scoped>
.message {
  position: relative;
  height: 755px;
}
</style>
